import CreateRouteData from "../../domain/weather_routing/create_route/data";
import createRouteDataToJson from "../../domain/weather_routing/create_route/mapper_to_json";
import customRouteFromJson from "../../domain/weather_routing/custom_route/mapper";
import RoutePointData from "../../domain/weather_routing/route_point/data";
import HttpError from "../../services/http_error";
import WeatherRoutingRouteService from "../../services/route/service";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;
const companyId = process.env.VUE_APP_COMPANY_ID;

const routeService = new WeatherRoutingRouteService(
  localWeatherRoutingServerUrl,
  companyId,
  customRouteFromJson,
  createRouteDataToJson,
);

const getDefaultState = () => {
  return {
    currentWayPoints: [],
    routeDescription: "",
    createRouteError: null,
    createRouteLoading: false,
    createRouteFailed: false,
    createRouteSuccess: false,
    routeIsVerified: false,
  };
};

const state = getDefaultState();

const getters = {
  getConstructedRouteGeoJson: (state) => {
    const pointFeatures = state.currentWayPoints.map((coord) => {
      return {
        "id": `${coord[0]}`,
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": coord
        },
        "properties": {
          title: "F",
        },
      };
    });
    return {
      type: "geojson",
      data: {
        id: "currentRoute",
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: state.currentWayPoints,
            },
            properties: {
              id: "currentRoute",
            },
          },
          ...pointFeatures
        ],
      },
    };
  },
  getConstructedRoutePointsGeoJson: () => {
    const pointFeatures = state.currentWayPoints.map((coord, index) => {
      return {
        "id": `${coord[0]}`,
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": coord
        },
        "properties": {
          title: `WP ${index}`,
        },
      };
    });
    return {
      type: "geojson",
      data: {
        id: "symbols",
        type: "FeatureCollection",
        features: [
          ...pointFeatures
        ],
      },
    };
  },
  getConstructedRouteLineLayer: () => {
    return {
      id: "currentRouteLine",
      type: "line",
      source: "currentRoute",
      layout: {
        "line-cap": "butt",
        "visibility": "visible"

      },
      paint: {
        "line-color": "#01579B",
        "line-width": 2,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getConstructedRoutePointsLayer: () => {
    return {
      id: "currentRoutePoints",
      type: "circle",
      source: "currentRoute",
      paint: {
        "circle-radius": 2.5,
        "circle-opacity": 0,
        "circle-stroke-width": 0.8,
        "circle-stroke-color": "#000"
      },
      filter: ["==", "$type", "Point"],
    };
  },
  getConstructedRouteSymbolLayer: () => {
    return {
      id: "symbols",
      type: "symbol",
      source: "symbols",
      "layout": {
        "text-field": ["get", "title"],
        "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
        "text-offset": [0, 1.25],
        "text-anchor": "top-right",
        "text-size": 8,
        "text-padding": 0,
      },
      "paint": {
        "text-color": "#01579B",
      }
    };
  }
};

const actions = {
  async createRoute({ commit, rootState, state }) {
    commit("SET_CREATE_LOADING_STATE");
    const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
    try {
      const routePointsData = state.currentWayPoints.map((point, index) =>
        new RoutePointData(
          index,
          point[1],
          point[0],
          null
        )
      );

      const createRouteData = new CreateRouteData(
        companyId,
        routePointsData,
        state.routeDescription,
        state.routeIsVerified
      );

      await routeService.post(
        localStorage.getItem("quad_token"),
        accessToken,
        createRouteData
      );
      commit("SET_CREATE_ROUTE_SUCCESS_STATE");
    } catch (e) {
      if (e instanceof HttpError) {
        commit("SET_CREATE_ROUTE_FAILED_STATE");
        return;
      }
      commit("SET_CREATE_ROUTE_FAILED_STATE");
    }
  }
};

const mutations = {
  SET_CURRENT_WAYPOINTS: (state, data) => {
    return (state.currentWayPoints = data);
  },
  SET_ROUTE_DESCRIPTION: (state, data) => {
    return (state.routeDescription = data);
  },
  SET_ROUTE_IS_VERIFIED: (state, data) => {
    return (state.routeIsVerified = data);
  },
  SET_CREATE_LOADING_STATE(state) {
    state.createRouteLoading = true;
    state.createRouteError = null;
    state.createRouteFailed = false;
    state.createRouteSuccess = false;
  },
  SET_CREATE_ROUTE_SUCCESS_STATE(state) {
    state.createRouteLoading = false;
    state.createRouteError = "";
    state.createRouteSuccess = true;
  },
  SET_CREATE_ROUTE_FAILED_STATE(state) {
    state.createRouteLoading = false;
    state.createRouteError = "Creation failed";
    state.createRouteFailed = true;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export const weatherRoutingCreateRouteModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
